import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  updateProfileSuccess,
  updateProfileFailure,
  updateProfileRequest,
} from '../reducers/updateProfile';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/updateProfile`;

function* updateProfileAxios() {
  const state = yield select(fullState => fullState);
  
  const { userId } = state.loginReducer.user;
  const { bio, file } = state.updateProfile;
  const { token } = state.loginReducer;
 
  const response = yield call(() =>
    axios({
      method: 'post',
      url: `${API}?user_id=${userId}&biography=${bio}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${token}`
      },
      data: {
       user_id:userId,
       bio: bio,
       file: file
      },
    }),
  );

  return response;
}

function* updateProfileSaga() {
  try {
    const response = yield call(updateProfileAxios);
    yield put(updateProfileSuccess(response.data));

  } catch (error) {
    yield put(updateProfileFailure(error));
  }
}

export function* watcherUpdateProfileSaga() {
  yield takeLatest(updateProfileRequest().type, updateProfileSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/post_updateProfile.js